import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  pickupContact: {
    description: 'orderDrawer.pickupInformation.pickupContact',
    defaultMessage: 'Pickup Contact',
    id: 'O43ARe',
  },
  pickupWindow: {
    description: 'orderDrawer.pickupInformation.pickupWindow',
    defaultMessage: 'Pickup Window',
    id: 'IZ6p3X',
  },
  pickupWindowTime: {
    description: 'orderDrawer.pickupInformation.pickupWindowTime',
    defaultMessage: '{startTime} - {endTime}, support delivery exception returns through operating hours',
    id: 'ZMq3Kf',
  },
  pickupInstruction: {
    description: 'orderDrawer.pickupInformation.pickupInstruction',
    defaultMessage: 'Pickup Instructions',
    id: 'GvgnKu',
  },
  failedShipFromContactsTitle: {
    description: 'orderDrawer.pickupContact.failedShipFromContactsTitle',
    defaultMessage: 'Failed to get Ship From Contacts',
    id: 'S+bn7y',
  },
  failedShipFromContactsContent: {
    description: 'orderDrawer.pickupContact.failedShipFromContactsContent',
    defaultMessage: 'An unexpected error occurred while loading contacts.',
    id: 'z1y3Ii',
  },
  localDeliveryPickupError: {
    description: 'orderDrawer.pickupContact.localDeliveryPickupError',
    defaultMessage: 'Local delivery needs a defined pickup window. <a>Edit Pickup Settings</a>',
    id: 'bVO4RE',
  },
  noContactSelected: {
    description: 'orderDrawer.pickupContact.noContactSelected',
    defaultMessage: 'No contact is selected for Ship From',
    id: 'enK+NX',
  },
});
